// Example for ProfilePhotoUploader.jsx
import React, { useRef, useState } from 'react'; // Added useState for preview
// CSS is imported by UserProfile.jsx

const ProfilePhotoUploader = ({ onUpload, currentImage }) => {
  const fileInputRef = useRef(null);
  const [preview, setPreview] = useState(currentImage); // For image preview
  const [uploadError, setUploadError] = useState('');

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    setUploadError('');
    if (!file) return;

    // UX: Basic file type and size validation
    if (!file.type.startsWith('image/')) {
        setUploadError('Please select an image file (jpeg, png, gif).');
        return;
    }
    if (file.size > 5 * 1024 * 1024) { // 5MB limit
        setUploadError('File is too large. Maximum size is 5MB.');
        return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      setPreview(reader.result); // Show local preview immediately
    };
    reader.readAsDataURL(file);

    const formData = new FormData();
    formData.append('photo', file); // Backend expects 'photo'

    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/users/upload-profile-photo`, {
        method: 'POST',
        headers: { Authorization: token }, // No Content-Type, FormData sets it
        body: formData,
      });

      const responseData = await res.json();
      if (!res.ok) {
        throw new Error(responseData.message || 'Profile photo upload failed');
      }
      onUpload(responseData.path); // Send new path to parent
    } catch (err) {
      setUploadError(err.message || 'An error occurred during upload.');
      console.error('Profile photo upload error:', err);
      setPreview(currentImage); // Revert preview on error
    } finally {
        if (fileInputRef.current) {
            fileInputRef.current.value = ''; // Clear file input
        }
    }
  };
  
  const effectivePreview = preview && preview.startsWith('blob:') ? preview : 
                         (preview ? (preview.startsWith('http') ? preview : `${process.env.REACT_APP_BACKEND_URL}${preview}`) : '/default-avatar.png');


  return (
    <div className="photo-upload-area">
      {/* <label>Change Profile Photo</label> */} {/* Label provided by section title */}
      {effectivePreview && (
        <img
          src={effectivePreview}
          alt="Profile preview"
          style={{ width: '100px', height: '100px', borderRadius: '50%', objectFit: 'cover', marginBottom: '1rem', border: '2px solid var(--border-color)' }}
          onError={(e) => { e.target.onerror = null; e.target.src='/default-avatar.png'; }}
        />
      )}
      <label htmlFor="profile-photo-input" className="file-input-styled-button btn btn-outline-primary">
        Choose New Photo
        <input
            id="profile-photo-input"
            type="file"
            ref={fileInputRef}
            onChange={handleFileChange}
            accept="image/jpeg, image/png, image/gif"
            style={{ display: 'none' }} // Hide default input, label acts as button
        />
      </label>
      {uploadError && <p className="error-message" style={{marginTop: '0.5rem'}}>{uploadError}</p>}
    </div>
  );
};
export default ProfilePhotoUploader;

// PhotoUploader.jsx (for gallery) would be very similar,
// just without the preview img element and using a different label/endpoint if needed.
// It would just call onUpload(responseData.path).